enum TicketSourceType {
  SOURCE_QUESTION_TYPE = 'Question',
  SOURCE_IT_ISSUE = 'IT Issue',
  SOURCE_NOT_ASSIGNED = 'Not Assigned',
  SOURCE_REMEDIAL_ACTION = 'Remedial Action',
}

export default TicketSourceType;
